import { useSortable } from '@dnd-kit/sortable';
import { CSS } from "@dnd-kit/utilities";
import { ArrowUp } from 'lucide-react';
import React from 'react';

interface SortableProductVariantImagesProps {
  asset: { id: string; url: string };
  publicAssetsUrl: string;
  onMoveUp: (id: string) => void;
}

export const SortableProductVariantImages: React.FC<SortableProductVariantImagesProps> = React.memo(({ asset, publicAssetsUrl, onMoveUp }) => {

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: asset.id });

    const style: React.CSSProperties = {
        width: "100px",
        height: "100px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        overflow: "hidden",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        cursor: "grab",
        transform: CSS.Transform.toString(transform),
        transition,
        flexShrink: 0,
        marginRight: "10px",
        background: "#fff",
    };

    const moveUpStyle: React.CSSProperties = {
        position: "absolute",
        top: "4px",
        right: "4px",
        width: "20px",           
        height: "20px",          
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(0,0,0,0.55)",
        borderRadius: "50%",
        cursor: "pointer",
        zIndex: 10,
        touchAction: "none",
    };
  
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} >
         <div style={moveUpStyle} 
        data-no-drag
        onClick={(e) => {
           e.stopPropagation();
           onMoveUp(asset.id); 
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0, 0, 0, 0.8)")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(0, 0, 0, 0.6)")}
        >
        <ArrowUp color="#fff" style={{ width: "15px", height: "15px", paddingRight:'1px', paddingTop:'1px' }} />
      </div>
        <img src={`${publicAssetsUrl}${asset.url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    </div>
  )
});
